export default __webpack_public_path__ + "static/media/es-im-img.d19247dc.webp";